<template>
  <router-view/>
</template>

<style>
  body {
    min-height: 100vh;
  }
</style>
